import { useTheme } from '../lib/theme';

/**
 * Hook to get the Monaco editor theme based on current app theme.
 * Returns 'vs' for light theme and 'vs-dark' for dark/midnight themes.
 */
export function useMonacoTheme(): string {
  const { monacoTheme } = useTheme();
  return monacoTheme;
}
